export const DIETS = ["Halal", "Vegan", "Vegetarian", "Gluten free", "Dairy Free"] as const;
